import { Modal, Table, Button } from "antd";
import { useEffect, useState } from "react";
import service from "../../../@services";
const statusMap = {
  '0': "待审核",
  '1': "审核通过",
  '2': "审核失败"
}
export default props => {
  const {visible,skuForStoreId,close,auditPrice = () => {}} = props
  const [dataSource, setTableData] = useState([])
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState({current: 1,pageSize: 10,})
  useEffect(()=>{
    setTableData([])
    if(visible){
      fetchData({skuForStoreId, pageIndex: 1, pageSize: 10})
    }
  },[visible])
  const handleTableChange = (pagination) => {
    setPagination(pagination)
    const params = { skuForStoreId, pageIndex: pagination.current, pageSize: pagination.pageSize}
    fetchData(params)
  }
  const fetchData = async (params) => {
    setLoading(true)
    const data = await service.price.getUpdateRecord(params)
    setLoading(false)
    if(data){
      setTableData(data.result)
      setPagination({
        current: data.pageIndex,
        pageSize: data.pageSize,
        total: data.recordCount
      })
    }
  }
  const columns = [
    { title: '申请单据', dataIndex: 'auditNo', key: 'auditNo',
      render: (text,record,index)=> (
        <Button type="link" onClick={()=>auditPrice(record.auditNo,record.auditStatus)}>{record.auditNo}</Button>
      )
    },
    { title: '操作描述', dataIndex: 'actDesc', key: 'actDesc' },
    { title: '状态', dataIndex: 'auditStatus', key: 'auditStatus',
      render: (auditStatus)=> (
        statusMap[auditStatus]
      )
    },
    { title: '操作人', dataIndex: 'operator', key: 'operator' },
    { title: '操作时间', dataIndex: 'createTime', key: 'createTime' }
  ]
  return (
    <Modal
      visible={visible}
      width="40%"
      title="调价记录"
      onCancel={close}
      footer={[]}
    >
      <Table
        rowKey={record=>record.id}
        dataSource={dataSource}
        columns={columns}
        loading={loading}
        pagination={pagination}
        onChange={handleTableChange}
      />
    </Modal>
  );
}
